import { render, staticRenderFns } from "./TopUpTable.vue?vue&type=template&id=6427fc7d&"
import script from "./TopUpTable.vue?vue&type=script&lang=js&"
export * from "./TopUpTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports